import { render, staticRenderFns } from "./GerenzxRight.vue?vue&type=template&id=2ea9c17d&scoped=true"
import script from "./GerenzxRight.vue?vue&type=script&lang=js"
export * from "./GerenzxRight.vue?vue&type=script&lang=js"
import style0 from "./GerenzxRight.vue?vue&type=style&index=0&id=2ea9c17d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9c17d",
  null
  
)

export default component.exports